import * as React from 'react';
import Style from './index.less';

export interface p {}

const BetaTag: React.FC<p> = () => {
  return !window.isPad ? (
    <></>
  ) : (
    <div className={Style['beta-tag']}>
      <span>BETA</span>
    </div>
  );
};

export default BetaTag;
